const defaultTextValues = {
  workShopBuyButton: {
    en: 'Register'
  },
  sectionTitle: {
    en: 'Workshop'
  },
  workshopDate: {
    en: '20 - 21 April 2022'
  }
};

export default defaultTextValues;
